<template>
    <ymapMarker
        :markerId="markerId"
        :coords="coords"
        :balloon-template="balloonTemplate"
        :options="{
            preset: 'islands#darkBlueAutoCircleIcon',
            hideIconOnBalloonOpen: false,
        }"
    />
</template>

<script>
import { ymapMarker } from 'vue-yandex-maps';

export default {
    props: ['markerId', 'coords', 'info'],
    name: 'carMarker',
    components: {
        ymapMarker,
    },
    computed: {
        balloonTemplate() {
            return `<div>${this.info.color} ${this.info.brand} ${
                this.info.model
            } ${this.info.state_number}</div><div>Экипаж:  ${
                this.info.board_number
            }</div><div>Статус: ${this.statusFormat(this.info.status)}</div>`;
        },
    },
    methods: {
        statusFormat(code) {
            switch (code) {
                case 1:
                    return 'Автомобиль ожидает';
                case 2:
                    return 'Автомобиль на вызове';
                case 3:
                    return 'Автомобиль в ремонте';
                case 4:
                    return 'Автомобиль недоступен';
                case 5:
                    return 'Автомобиль оповещён';
                case 6:
                    return 'Вызов завершён';
                default:
                    return 'Неизвестно';
            }
        },
    },
};
</script>

<style scoped></style>
